import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

function LegalSection({ title, children }) {
  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="h6" component="h2" sx={{ fontWeight: 700, mb: 1 }}>
        {title}
      </Typography>
      {children}
    </Box>
  );
}

function Privacy() {
  return (
    <Box sx={{ maxWidth: 720 }}>
      <Typography variant="h4" component="h1" sx={{ fontWeight: 700, mb: 1 }}>
        Privatlivspolitik
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Senest opdateret: 28. august 2026
      </Typography>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Denne privatlivspolitik beskriver, hvordan sorenkoelbaek.dk (&quot;sitet&quot;, &quot;vi&quot;)
        behandler personoplysninger. Sitet drives som en privat, invitationsbaseret
        hjemmeside.
      </Typography>

      <LegalSection title="Dataansvarlig">
        <Typography variant="body1">
          Dataansvarlig er indehaveren af sorenkoelbaek.dk. Spørgsmål om persondata kan
          rettes via kontaktoplysningerne på sitet.
        </Typography>
      </LegalSection>

      <LegalSection title="Hvilke oplysninger vi behandler">
        <Typography variant="body1" component="div">
          Afhængigt af hvordan du bruger sitet kan vi behandle:
          <ul>
            <li>Kontooplysninger: brugernavn, e-mail og adgangskode (gemt som hash)</li>
            <li>Indhold du opretter, f.eks. kommentarer, og valgfrit profilbillede</li>
            <li>Tekniske logoplysninger, der er nødvendige for at drive og sikre sitet</li>
            <li>
              Bank- og forbrugsoplysninger, kun som beskrevet under &quot;Økonomi og
              bankdata&quot;
            </li>
          </ul>
        </Typography>
      </LegalSection>

      <LegalSection title="Økonomi og bankdata">
        <Typography variant="body1" sx={{ mb: 1.5 }}>
          Sitet kan forbinde til bankkonti via Enable Banking, så transaktioner kan
          hentes og vises i en privat økonomioversigt.
        </Typography>
        <Typography variant="body1" sx={{ mb: 1.5 }}>
          <strong>
            Ingen almindelig bruger har adgang til økonomi- eller bankdata.
          </strong>{" "}
          Adgang er forbeholdt den bruger, der er udpeget som administrator på
          platformen. En administrator kan kun se sine egne bankkonti og
          transaktioner — altså data, der stammer fra den administrators egen
          bankgodkendelse. Administratoren kan ikke se andre brugeres økonomiske
          oplysninger, og andre brugere kan ikke se administratorens.
        </Typography>
        <Typography variant="body1">
          Banklogin sker hos banken. Vi gemmer ikke din netbank-adgangskode. Vi
          gemmer en sessionsnøgle, kontoliste og transaktionstekster/beløb, så
          oversigten kan vises og opdateres. Behandlingen sker med henblik på
          privat budgetoversigt for administratoren.
        </Typography>
      </LegalSection>

      <LegalSection title="Retsgrundlag og opbevaring">
        <Typography variant="body1">
          Behandling sker for at drive sitet, opfylde din anmodning (f.eks.
          oprettelse med invitationskode) og, for økonomifunktionen, på grundlag
          af administratorens eget samtykke over for banken/Enable Banking.
          Oplysninger opbevares, så længe kontoen er aktiv, eller indtil de slettes
          af os. Bankforbindelsen kan afsluttes, hvorefter nye træk fra banken
          stopper.
        </Typography>
      </LegalSection>

      <LegalSection title="Videregivelse">
        <Typography variant="body1">
          Vi sælger ikke personoplysninger. Vi deler kun det, der er nødvendigt med
          leverandører, der hjælper med at drive sitet (hosting, e-mail) og med
          Enable Banking, når administratoren selv forbinder en bank. Myndigheder
          kan få oplysninger, hvis loven kræver det.
        </Typography>
      </LegalSection>

      <LegalSection title="Dine rettigheder">
        <Typography variant="body1">
          Du kan anmode om indsigt, berigtigelse eller sletning af de
          personoplysninger, vi har om dig, i det omfang loven giver ret til det.
          Du kan klage til Datatilsynet.
        </Typography>
      </LegalSection>

      <LegalSection title="Cookies">
        <Typography variant="body1">
          Sitet bruger lokal lagring i browseren til at holde dig logget ind
          (adgangs- og opdateringstokens). Vi bruger ikke tredjepartsannoncekager.
        </Typography>
      </LegalSection>
    </Box>
  );
}

export default Privacy;
